<template>
    <div style="display: contents">
        <canvas ref="pdfPreview" class="pdfViewer object-fit-cover position-absolute t-0 l-0"></canvas>
    </div>
</template>

<script>
    import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.js';
    import * as pdfworker from 'pdfjs-dist/legacy/build/pdf.worker.entry.js'

    export default {
        props: ['file','url'],
        methods: {
            loadingTask (loadingTask) {
                let canvas = this.$refs.pdfPreview;
                loadingTask.promise.then(function(pdf) {

                    // Fetch the first page
                    let pageNumber = 1;
                    pdf.getPage(pageNumber).then(function(page) {

                        let scale = 1.5;
                        let viewport = page.getViewport({scale: scale});

                        // Prepare canvas using PDF page dimensions
                        let context = canvas.getContext('2d');
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        // Render PDF page into canvas context
                        let renderContext = {
                            canvasContext: context,
                            viewport: viewport
                        };
                        page.render(renderContext);
                    });
                }, function (reason) {
                    // PDF loading error
                    console.error(reason);
                });
            },
            renderPreview () {
                if( this.url ) {
                    this.loadingTask(pdfjsLib.getDocument(this.url))
                }
                else if( this.file ) {
                    if(this.file.type === "application/pdf" ){
                        let fileReader = new FileReader();
                        let loadingTask = this.loadingTask
                        fileReader.onload = function() {
                            let pdfData = new Uint8Array(this.result);
                            // Using DocumentInitParameters object to load binary data.
                            loadingTask(pdfjsLib.getDocument({data: pdfData}))
                        };
                        fileReader.readAsArrayBuffer(this.file);
                    }
                }
            },
        },
        mounted() {
            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfworker
            this.renderPreview();
        },
        watch: {
            file: {
                handler() {
                    this.renderPreview()
                }
            },
        }
    }
</script>